import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '@environment/environment';
import { LoggerService } from '@app/core/infrastructure';
import { AnalyticsQueryParams } from '../analytics-shared';
import { MatchingOverview } from './matching-analytics-api.models';

/**
 * Pure API service for matching analytics HTTP operations
 * No state management — just HTTP calls
 */
@Injectable({
  providedIn: 'root'
})
export class MatchingAnalyticsApiService {
  private readonly logger = inject(LoggerService).scope('MatchingAnalyticsApiService');

  private readonly baseUrl = `${environment.API_BASE_URL}/protected/care/analytics/matching`;

  constructor(private http: HttpClient) {
    this.logger.debug('Initialized');
  }

  /**
   * GET /protected/care/analytics/matching/overview
   * Matching request and approved request counts for a date range.
   */
  public getOverview(params: AnalyticsQueryParams): Observable<MatchingOverview> {
    const httpParams = new HttpParams()
      .set('user_id', params.user_id)
      .set('start_date', params.start_date)
      .set('end_date', params.end_date);

    return this.http.get<MatchingOverview>(`${this.baseUrl}/overview`, { params: httpParams }).pipe(
      catchError(error => {
        this.logger.error('Error fetching matching overview:', error);
        return throwError(() => new Error('Failed to fetch matching overview'));
      })
    );
  }
}
